<!-- Please don’t change these IDs because those are for automated testing: localeIdsSelectBox, searchTopInput, addNewMapBtn, mapActionDropDown, mapEditActionLink, mapDeleteActionLink, mapDeleteActionLink, pagePagination -->
<div class="mid_container top__padding">
  <div class="top__main pages__filter">
    <div class="container">
      <div class="main_hd_page_top main_hd_page_top__manage_map">
        <div class="row">
          <div class="col-lg-5 col-md-4 col-sm-5">
            <h1 class="pg__heading">{{translations.GLOBAL.KEYS.CHALLENGES_MAPS | translate}}</h1>
          </div>
          <div class="col-lg-7 col-md-8 col-sm-7">
            <div class="main_hd_page_top_right">
              <app-locale-search-box
                class ="authbox-select text-left"
                [setLocaleOption]="localeListBindValueField._id"
                [setMultiple] ='"true"'
                [showLocaleOption]="localeListBindLabelField.localepath"
                (localeSelected)="searchByLocale($event)">
              </app-locale-search-box>
              <app-text-search
                class="global-search"
                [placeholder]="isClearValue ? clearSearchValue() : getTranslation(translations.GLOBAL.KEYS.SEARCH_MAP)"
                (textSearchTriggered)="searchByText($event)">
              </app-text-search>
            </div>
          </div>
        </div>
      </div>
      <div class="main_hd_page_btm">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6"></div>
          <div class="col-lg-6 col-md-6 col-sm-6 text-right">
            <div class="add__new__btn">
              <a [ngClass]="isMapFormVisible ? 'filled':''" class="btn_outline" (click)="toggleForm(true)"
                id="addNewMapBtn" href="javascript:void(0);"> {{translations.GLOBAL.KEYS.CREATE_MAP | translate}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container admin-map-page">
    @if (isMapFormVisible) {
      <div id="shownew" class="create__new__form__section">
        <button class="div_close" (click)="toggleForm()" id="createformclose">
          <img src="/assets/images/svg_icons/cross.svg" alt="" />
        </button>
        <div class="create__new__form__in">
          <h1>{{translations.GLOBAL.KEYS.CREATE_MAP | translate}}</h1>
          @if (isMapFormVisible) {
            <app-map-form
              [token]="token"
              [mapToBeEdited]="mapList[editIndex]"
              (mapFormClosed)="toggleForm()"
              (mapCreated)="showSuccessMessageForMapCreation()"
              (mapCreationErrorOccured)="showErrorMessageForMapCreation()"
              (mapUpdated)="showSuccessMessageForMapUpdation()"
              (mapUpdationErrorOccured)="showErrorMessageForMapUpdation()">
            </app-map-form>
          }
        </div>
      </div>
    }
    <div class="main__row margin__top_25">
      @if (mapList?.length===0 && !isMapFormVisible) {
        <div class="not-found not-found-message">{{ translations.GLOBAL.ERROR_MESSAGES.NO_RECORD_FOUND | translate}}</div>
      }
      @for (map of mapList; track map; let mapIndex = $index) {
        <div class="list__box">
          @if (editIndex !== mapIndex;) {
            <div class="main__row__list base-list" id="HideBox1">
              <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10">
                  <div class="simple__info">
                    <h2 class="hd-with-tags">
                      <div class="hd-with-tags-left">  {{map.name}} </div>
                      <div class="hd-with-tags-tright">
                        @if (map.mapType === mapType[mapTypeEnum.AUTO].Value) {
                          <span class="span__tags">
                            {{translations.GLOBAL.KEYS[mapType[mapTypeEnum.AUTO].Label] | translate}}
                          </span>
                        }
                        @if (map.mapType === mapType[mapTypeEnum.MANUAL].Value) {
                          <span class="span__tags">
                            {{translations.GLOBAL.KEYS[mapType[mapTypeEnum.MANUAL].Label] | translate}}
                          </span>
                        }
                      </div>
                    </h2>
                    <div class="status-with-type">
                      <ul>
                        <li >{{status[map.status].label}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 custom-justify-content-end">
                  <div class="action__filter">
                    <div class="action dropdown action-dropdown-right" dropdown>
                      <div id="dropdownAction" dropdownToggle class="dropdown-toggle">
                        <a id="mapActionDropDown" href="javascript:void(0)">{{translations.GLOBAL.KEYS.ACTION | translate}}</a>
                      </div>
                      <div class="dropdown-menu" id="dropdown-basic" *dropdownMenu>
                        <a class="dropdown-item" id="mapEditActionLink" href="javascript:void(0)"
                          (click)="setChallengeMapForEdit(mapIndex)">
                          {{translations.GLOBAL.KEYS.EDIT | translate}}
                          <i><img src="/assets/images/svg_icons/edit.svg" alt="" /></i>
                        </a>
                        <a class="dropdown-item" id="mapDeleteActionLink" href="javascript:void(0)"
                          (click)="setChallengMapForCopy(map)">
                          {{translations.GLOBAL.KEYS.COPY | translate}}
                          <i><img src="/assets/images/copy-icon.png" alt="" /></i>
                        </a>
                        <a class="dropdown-item" id="mapDeleteActionLink" href="javascript:void(0)"
                          (click)="openDeletePopup(map._id)">
                          {{translations.GLOBAL.KEYS.DELETE | translate}}
                          <i><img src="/assets/images/svg_icons/gray_delete.svg" alt="" /></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (editIndex === mapIndex;) {
            <div class="edit__row__box" id="listeditbox1">
              <button class="div_close" id="close10" (click)="toggleForm()">
                <img src="/assets/images/svg_icons/cross.svg" alt="">
              </button>
              <div class="edit__row__in__box">
                <h1>{{translations.GLOBAL.KEYS.EDIT | translate}} :- {{map.name}} </h1>
                @if (editIndex===mapIndex) {
                  <app-map-form
                    [token]="token"
                    [mapToBeEdited]="mapList[editIndex]"
                    (mapFormClosed)="toggleForm()"
                    (mapCreated)="showSuccessMessageForMapCreation()"
                    (mapCreationErrorOccured)="showErrorMessageForMapCreation()"
                    (mapUpdated)="showSuccessMessageForMapUpdation()"
                    (mapUpdationErrorOccured)="showErrorMessageForMapUpdation()">
                  </app-map-form>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (pageAttributes.count > 10) {
        <div class="pagination_nav">
          <pagination id="pagePagination" [totalItems]="pageAttributes.count" [rotate]="pageAttributes.rotate" [maxSize]="pageAttributes.maxSize"
            [itemsPerPage]="pageAttributes.limits" [(ngModel)]='currentPage' (pageChanged)="pageChanged($event);">
          </pagination>
        </div>
      }
    </div>
  </div>
</div>

